<template>
    <div class="indicators-tab">
        <a
            class="indicators-tab__block indicators-tab__block--data-book"
            :href="bookLink"
            target="_blank"
            :style="`background-image: url(${bookImage}) `"
        >
            <z-icon
                width="62"
                height="36"
                name="file/text-xlsx"
            />
            <span class="presentation-tab__pdf-name">{{ bookName }}</span>
        </a>
        <z-figure
            class="indicators-tab__block"
            :image="figureImage"
            :caption="figureName"
            theme="blue"
            :link="figureLink"
            icon-name="arrow-long"
            icon-width="24"
            icon-height="24"
            size="l"
        />
    </div>
</template>
<script>
export default {
    name: 'IndicatorsTab',
    props: {
        bookName: String,
        bookLink: String,
        bookImage: String,
        figureName: String,
        figureLink: String,
        figureImage: String
    }
}
</script>
<style lang="scss">
.indicators-tab {
    display: flex;
    gap: $token-spacers-2-s;

    @include breakpoint(v-tablet) {
        flex-direction: column;
    }

    &__block {
        max-width: 612px;
        flex: 1 1 50%;

        &.z-figure {
            max-width: 612px;
            border-radius: 0 0 40px 0;
        }

       &--data-book {
           padding:$token-spacers-l $token-spacers-m;
           display: flex;
           flex-direction: column;
           justify-content: flex-end;
           background-repeat: no-repeat;
           background-position: center;
           background-size: 100%;
           text-decoration: none;
           border-radius: 0 40px 0 20px;
           aspect-ratio: 16/9;
           transition: all 0.6s ease-in-out;

           & .z-icon {
               width: 62px;
               height: 36px;
               border: 1px solid white;
               padding: 8px;
               border-radius: 50px;

               & path {
                   fill: #fff;
               }
           }

           &:hover {
               padding-left: calc(#{$token-spacers-m} + 8px);
               background-size: 120%;
           }
       }
    }
}
</style>
